// pages/admin/components/AdminNotifications.js
import React from 'react';
import { useAdmin } from '../../../contexts/AdminContext';

const AdminNotifications = () => {
  const { notifications, removeNotification } = useAdmin();

  if (notifications.length === 0) {
    return null;
  }

  return (
    <div className="admin-notifications-container">
      {notifications.map(notification => (
        <div 
          key={notification.id}
          className={`admin-notification admin-notification-${notification.type}`}
        >
          <div className="admin-notification-content">
            <div className="admin-notification-icon">
              {notification.type === 'success' && <i className="fas fa-check-circle"></i>}
              {notification.type === 'error' && <i className="fas fa-exclamation-circle"></i>}
              {notification.type === 'warning' && <i className="fas fa-exclamation-triangle"></i>}
              {notification.type === 'info' && <i className="fas fa-info-circle"></i>}
            </div>
            <div className="admin-notification-message">
              {notification.message}
            </div>
          </div>
          <button 
            className="admin-notification-close"
            onClick={() => removeNotification(notification.id)}
          >
            <i className="fas fa-times"></i>
          </button>
        </div>
      ))}
    </div>
  );
};

export default AdminNotifications;